import firebase from "datastore/database";
import store from "datastore/store";

import { selectBranchUser } from "selectors/authedUser";

export default function observeBusinessUsers(businessUid) {
  store.dispatch({ type: "ADD_BUSINESS_USERS_LOADING" });

  return firebase
    .firestore()
    .collection("users")
    .where("businessUids", "array-contains", businessUid)
    .onSnapshot(
      (snapshot) => {
        const users = {};

        snapshot.forEach((doc) => {
          const userData = doc.data();
          const branchUser = selectBranchUser(userData, businessUid);
          if (branchUser) {
            users[doc.id] = {
              ...userData,
              ...branchUser,
            };
          }
        });

        store.dispatch({ type: "ADD_BUSINESS_USERS_SUCCESS", users });
      },
      (error) => {
        store.dispatch({ type: "ADD_BUSINESS_USERS_ERROR", error });
      }
    );
}
